/*
 * @Author: 刘小博
 * @Date: 2023-02-15 17:21:57
 * @LastEditTime: 2023-02-17 18:08:15
 * @LastEditors: 刘小博
 * @Description: 
 * @FilePath: \p2ps_vip_web\src\router\agreement-manage\system-settings\index.js
 * 文件备注
 */
import systemSettingRouter from './modules/systemSettingRouter'
const systemSettingsRouter = [].concat(systemSettingRouter)
export default systemSettingsRouter